/* @flow */
export default {
    updateConfirmation: {
        title: 'Confirmation',
        message: 'Are you sure you want to update this calendar entry?',
        confirm: 'Yes',
        cancel: 'Cancel',
    },
};
